
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

require('cookieconsent');

import 'jquery-ui/ui/effects/effect-shake.js';

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

$(document).ready(function() {
    window.addEventListener("load", function() {
        if ($('.cc-page')[0]) {
            $('#cc-allow-text')[0].onclick = function () {
                allowCookie()
                // p.setStatus(cookieconsent.status.allow);
                // p.close();
            };
            $('#cc-deny-text')[0].onclick = function () {
                removeCookie()
                // p.setStatus(cookieconsent.status.deny);
                // p.close();
            };
        }
    });
    $("input.termChecker").click(function(){
        f($(this).closest('td'), $(this).is(':checked'));
    });
    $("div[class^=termSuccessSwitch]").click(function () {
        let $checker = $(this).find("input.termChecker");
        console.log($checker);
        if($checker.is(':checked'))
            $checker.prop('checked', false);
        else
            $checker.prop('checked', true);
        f($(this).closest('td'), $checker.is(':checked'));
    });
    $("input[class^='sizeToParent']").each(function () {
        $(this).height($(this).parent().height());
    });
    $("#hOutside").click(function( event ) {
        event.preventDefault();
        setCookie("instSeen1", "true", 365);
        var form = $(".helper");
        let maxWidth = form.get(0).dataset.maxwidth;
        form.stop();
        if (form.css('width') === '0px') {
            form.animate({width: maxWidth+"px", height: "200px"}, 500);
        } else {
            form.animate({width: "0px", height: "0px"}, 500);
        }
    });
    $("#infoIcon").click(function( event ) {
        event.preventDefault();
        setCookie("instSeen2", "true", 365);
        var form = $(".helper2");
        var item = $(".hOutside2");
        form.stop();
        if (form.css('width') === '0px') {
            form.animate({width: "400px", height: "200px"}, 500);
            form.css({'border-width': "1px"});
            form.css({'top': item.offsetHeight + item.offsetTop+"px"});
        } else {
            form.animate({width: "0px", height: "0px"}, 500);
            form.css({'border-width': "0px"});
        }
    });
    $('#excelDownload').click(function () {
        $("#fileModal").modal();
        var content = $('div.fileContent').get(0);
        content.innerHTML = this.dataset.lang;
    });
});

$(document).ready(function(){
    let currency = $('input[name^="currencyString"]');
    if(currency.length > 0) {
        let currencyString = currency[0].value;
        let $items = $("table.itemTable input.itemPrice");
        $items.keypress(validateNumber);
        $items.each(function() {
            $(this).keyup(function(){
                let $prevTd = $(this).parent().prev('td');
                if($prevTd.hasClass("itemBp"))
                    $prevTd = $prevTd.prev('td');
                let itemCount = Number($prevTd.text().replace(",", ".").replace(new RegExp(" ", "g"), ""));
                let priceValue = Number($(this).val().replace(",", ".").replace(new RegExp(" ", "g"),""));
                if(!isNaN(itemCount) && !isNaN(priceValue)) {
                    let sumprice = (+itemCount * +priceValue);
                    $(this).parent().next('td').text(format(sumprice)+" "+currencyString);
                    calculateSum(currencyString)
                }
            });
            let $prevTd = $(this).parent().prev('td');
            if($prevTd.hasClass("itemBp"))
                $prevTd = $prevTd.prev('td');
            let itemCount = Number($prevTd.text().replace(",", ".").replace(new RegExp(" ", "g"), ""));
            let priceValue = Number($(this).val().replace(",", ".").replace(new RegExp(" ", "g"),""));
            if(!isNaN(itemCount) && !isNaN(priceValue)) {
                let sumprice = (+itemCount * +priceValue);
                $(this).parent().next('td').text(format(sumprice)+" "+currencyString);
            }
        });
        calculateSum(currencyString);
        setTimeout( "shakeMe2()", 5000 );
        let infoKey = $('div.itemInfoKey');
        if(infoKey.length > 0) {
            infoKey.get(0).style.width = $('th.groupName')[0].offsetWidth+'px';
        }
        $("table.itemTable input.priceParam").keypress(validateNumber);
    } else {
        setTimeout( "shakeMe1()", 5000 );
        $( window ).resize(function () {
            calcHeaderSize();
        });
        calcHeaderSize();
    }
    if($('div.triggerModal').length) {
        $("#myModal").modal()
    }
});

window.f = function ($closestTd, $checked) {
    if($checked){
        $closestTd.find('input.term-input').addClass("block grayBg");
    } else {
        $closestTd.find('input.term-input').removeClass("block grayBg");
    }
}
window.calcHeaderSize = function () {
    let header = $('#redHeader')[0];
    if(header) {
        let bound = header.getBoundingClientRect();
        let item = $('.helper');
        item.get(0).dataset.maxwidth = Math.min(400, bound.right - header.offsetWidth);
        item.css({'top': bound.top + 'px', 'left': header.offsetWidth + bound.left + 'px'})
    }
}
window.calculateSum = function (currencyString) {
    let table = $("table.itemTable");
    table.each(function () {
        let sum = 0;
        $(this).find("td.calcSum").each(function () {
            sum += Number($(this).text().replace(",", ".").replace(" "+currencyString, "").replace(new RegExp(" ", "g"), ""));
        });
        $(this).find("td.priceSumValue").text(format(sum)+" "+currencyString);
    });
}
window.format = function (num){
    return num.toFixed(2).replace('.', ',');
}
window.validateNumber = function (event) {
    let key = window.event ? event.keyCode : event.which;
    if ((~event.target.value.indexOf(".") || ~event.target.value.indexOf(",")) && (key === 46 || key === 44 || key === 108))
        return false;
    if (key === 8 || key === 46 || key === 44 || key === 108) {
        return true;
    } else return !(key < 48 || key > 57);
}
window.shakeMe1 = function (){
    if(notShaked('instSeen1')) {
        $('#hOutside').effect("shake", {direction: 'left', distance: 10, times: 4}, 1000,
            setTimeout( "shakeMe1()", 8000 ));
    }
}
window.shakeMe2 = function (){
    if(notShaked('instSeen2')) {
        $('#infoIcon').effect("shake", {direction: 'left', distance: 10, times: 4}, 1000,
            setTimeout( "shakeMe2()", 8000 ));
    }
}
window.notShaked = function ($cookieName){
    return getCookie($cookieName) !== "true";
}
window.getCookie = function (cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
window.setCookie = function (cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}


window.removeCookie = function() {
    expireCookie('_ga');
    expireCookie('_gat_gtag_UE_112775576_1');
    expireCookie('_gat_gtag_UA_112775576_1');
    expireCookie('_gid');
    location.reload();
}
window.allowCookie = function() {
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'UA-112775576-1');
}
window.expireCookie = function(cname) {
    var d = new Date();
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=;" + expires + ";path=/";
}

